import {IonicPageModule} from 'ionic-angular';
import {NgModule} from '@angular/core';
import {UserTaskInfoPage} from './user-task-info';

@NgModule({
  declarations: [UserTaskInfoPage],
  imports: [IonicPageModule.forChild(UserTaskInfoPage)],
})
export class UserTaskInfoModule {
}



// WEBPACK FOOTER //
// ./src/modules/user-tasks/pages/user-task-preview/info/user-task-info.module.ts